import ProviderReturnsContainer from './ProviderReturnsContainer';

export default ProviderReturnsContainer;
